<template>
    <div class="company">
        <div style="display: flex; justify-content: space-between; align-items: baseline">
            <PageTitle main="Empresas" sub="" />
            <b-button v-show="!modalActive && !modalActiveCertif" id="btn-principal" variant="success" @click="addCompany()" size="lgx" class="mb-2" v-if="user.emp_adi">  
                <i class="fa fa-plus"></i> Adicionar
            </b-button>
        </div>

        <div id="pageGrid" v-show="!modalActive && !modalActiveCertif">
            <b-table :items="companys" :fields="fields"
                responsive 
                striped
                borderless>
                <template slot="nm_empresa" slot-scope="data">
                    {{ data.item.nm_empresa }} <br>
                    <span style="font-size: smaller;">Nome fantasia: {{ data.item.nm_fantasia }}</span>
                </template>
                <template slot="actions" slot-scope="data">
                    <b-button variant="primary" @click="loadCompany(data.item)" size="sm mr-2">  
                        <i class="fa fa-pencil"></i>
                    </b-button>
                    <b-button variant="danger" @click="removeCompany(data.item)" size="sm mr-2" v-if="user.emp_exc">  
                        <i class="fa fa-trash"></i>
                    </b-button>
                    <b-button variant="dark" @click="loadCompanyCertificate(data.item)" size="sm mr-2" v-if="user.emp_edi">  
                        <i class="fa fa-lock"></i>
                    </b-button>
                </template>
            </b-table>
            <b-pagination class="customPagination mt-4" size="md" v-model.trim="page" :total-rows="count" :per-page="limit" />
        </div>
        
        <b-modal ref="modalRemove" hide-footer hide-header centered title="Confirmação!">
            <p class="my-4" style="text-align: center;">Deseja realmente excluir esta empresa?</p>
            <template v-slot:modal-footer="{ hideRemove , confirmeRemove }">
                <b-row class="text-center mb-4" align-v="center" style="padding: 20px 0px 0px 0px;"> 
                    <b-col xs="12" class="mb-1">
                        <b-button variant="danger" class="mr-2"
                            @click="confirmeRemove()">Excluir 
                        </b-button>
                        <b-button class="mr-2"
                            @click="hideRemove()">Cancelar
                        </b-button>
                    </b-col>
                </b-row>
            </template>
        </b-modal>       

        <div id="pageEdition" v-show="modalActive && !modalActiveCertif">
            <b-card :header="tituloModal"> 

                <b-form @submit.prevent="submit">
                    <div class="title-emp">
                        <p>Dados da Empresa</p>
                    </div>

                    <input id="usuario_id" type="hidden" v-model.trim="this.$store.state.user.userid"> 
                    
                    <input id="company-id" type="hidden" v-model.trim="company.empresa_id"> 

                    <b-row>
                        <b-col md="3" sm="12">
                            <b-form-group label="*Razão Social" label-for="company-razao">
                                <b-form-input 
                                    type="text" 
                                    id="company-razao" 
                                    name="company-razao"
                                    ref="company-razao"
                                    v-focus
                                    v-model.trim="company.razao" 
                                    :class="{ 'form-control is-invalid' : $v.company.razao.$error }"
                                    :readonly="((!isInsert) && (!this.$store.state.user.emp_edi))" 
                                    maxlength="100"
                                    placeholder="Informe a razão social">  

                                </b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col md="3" sm="12">
                            <b-form-group label="*Fantasia" label-for="company-fantasia">
                                <b-form-input 
                                    type="text"
                                    id="company-fantasia" 
                                    name="company-fantasia" 
                                    ref="company-fantasia"
                                    v-model.trim="company.fantasia" 
                                    :class="{ 'form-control is-invalid' : $v.company.fantasia.$error }"
                                    :readonly="((!isInsert) && (!this.$store.state.user.emp_edi))"                          
                                    maxlength="100"
                                    placeholder="Informe a fantasia">
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col md="3" sm="12">
                            <b-form-group label="*CNPJ" label-for="company-cnpj">
                                <b-form-input 
                                    type="text"
                                    id="company-cnpj" 
                                    name="company-cnpj" 
                                    ref="company-cnpj" 
                                    v-model.trim="company.cnpj" 
                                    :class="{ 'form-control is-invalid' : $v.company.cnpj.$error }"
                                    v-mask="'##.###.###/####-##'"
                                    :readonly="((!isInsert) && (!this.$store.state.user.emp_edi))"                             
                                    placeholder="Informe o CNPJ">
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col md="3" sm="12">
                            <b-form-group label="*Inscrição Municipal" label-for="company-im">
                                <b-form-input 
                                    type="text" 
                                    id="company-im" 
                                    name="company-im" 
                                    ref="company-im" 
                                    v-model.trim="company.im" 
                                    :class="{ 'form-control is-invalid' : $v.company.im.$error }"
                                    :readonly="((!isInsert) && (!this.$store.state.user.emp_edi))"          
                                    maxlength="15" 
                                    placeholder="Informe a inscrição municipal">
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="2" sm="12">
                            <b-form-group label="*CEP" label-for="company-cep">
                                <b-input-group class="mb-2 custom-input-group">
                                    <b-form-input 
                                        type="text"
                                        id="company-cep" 
                                        name="company-cep" 
                                        ref="company-cep" 
                                        v-model.trim="company.cep" 
                                        :class="{ 'form-control is-invalid' : $v.company.cep.$error }"
                                        :readonly="((!isInsert) && (!this.$store.state.user.emp_edi))" 
                                        placeholder="Informe CEP"
                                        maxlength="10">
                                    </b-form-input>
                                    <!-- v-mask="'##.###-###'" -->
                                    <b-input-group-append>
                                        <b-button size="sm" text="Button" variant="secondary" class="custom-search-button" 
                                            @click="buscarCep"
                                            :disabled="((!isInsert) && (!this.$store.state.user.emp_edi))">
                                            <i class="fa fa-search"></i>
                                        </b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col md="5" sm="12">
                            <b-form-group label="*Endereço" label-for="company-endereco">
                                <b-form-input 
                                    type="text"
                                    id="company-endereco" 
                                    name="company-endereco" 
                                    ref="company-endereco" 
                                    v-model.trim="company.endereco" 
                                    :class="{ 'form-control is-invalid' : $v.company.endereco.$error }"
                                    :readonly="((!isInsert) && (!this.$store.state.user.emp_edi))"    
                                    maxlength="100"                         
                                    placeholder="Informe o endereço">
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col md="2" sm="12">
                            <b-form-group label="*Número" label-for="company-numero">
                                <b-form-input 
                                    type="text"
                                    id="company-numero" 
                                    name="company-numero" 
                                    ref="company-numero" 
                                    v-model.trim="company.numero" 
                                    :class="{ 'form-control is-invalid' : $v.company.numero.$error }"
                                    :readonly="((!isInsert) && (!this.$store.state.user.emp_edi))"     
                                    maxlength="10"                         
                                    placeholder="Informe o número">
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col md="3" sm="12">
                            <b-form-group label="*Bairro" label-for="company-bairro">
                                <b-form-input 
                                    type="text"
                                    id="company-bairro" 
                                    name="company-bairro" 
                                    ref="company-bairro" 
                                    v-model.trim="company.bairro" 
                                    :class="{ 'form-control is-invalid' : $v.company.bairro.$error }"
                                    :readonly="((!isInsert) && (!this.$store.state.user.emp_edi))"                             
                                    maxlength="30" 
                                    placeholder="Informe o bairro">
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="3" sm="12">
                            <b-form-group label="Complemento" label-for="company-complemento">
                                <b-form-input 
                                    type="text"
                                    id="company-complemento" 
                                    name="company-complemento" 
                                    ref="company-complemento" 
                                    v-model.trim="company.complemento" 
                                    :readonly="((!isInsert) && (!this.$store.state.user.emp_edi))"       
                                    maxlength="70"                      
                                    placeholder="Informe o complemento">
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col md="6" sm="12">
                            <b-form-group label="*Município/UF" label-for="company-municipio_id"  :state="company.municipio_id" invalid-feedback="Este campo é obrigatório" > 
                                <b-form-select 
                                    id="company-municipio_id"
                                    name="company-municipio_id"
                                    ref="company-municipio_id"
                                    :options="citiesCache" 
                                    v-model.trim="company.municipio_id" 
                                    :readonly="((!isInsert) && (!this.$store.state.user.emp_edi))"       
                                    :class="{ 'form-control is-invalid' : $v.company.municipio_id.$error }">
                                </b-form-select>     
                            </b-form-group>
                        </b-col>

                        <b-col md="3" sm="12">
                            <b-form-group label="*Telefone" label-for="company-telefone">
                                <b-form-input 
                                    type="text"
                                    id="company-telefone" 
                                    name="company-telefone" 
                                    ref="company-telefone" 
                                    :class="{ 'form-control is-invalid' : $v.company.telefone.$error }"
                                    v-model.trim="company.telefone" 
                                    v-mask="'(##) #########'"
                                    :readonly="((!isInsert) && (!this.$store.state.user.emp_edi))"                             
                                    placeholder="Informe o telefone">
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="5" sm="12">
                            <b-form-group label="*E-mail" label-for="company-email">
                                <b-form-input 
                                    type="text"
                                    id="company-email" 
                                    name="company-email" 
                                    ref="company-email" 
                                    v-model.trim="company.email" 
                                    :class="{ 'form-control is-invalid' : $v.company.email.$error }"
                                    :readonly="((!isInsert) && (!this.$store.state.user.emp_edi))"                             
                                    maxlength="50" 
                                    placeholder="Informe o e-mail">
                                </b-form-input>
                                <!--<span v-if="$v.company.email.$error">E-mail is required!!</span>-->
                            </b-form-group>
                        </b-col>
                        <b-col md="3" sm="12">
                            <b-form-group label="*Regime Tributário" label-for="company-regime_tributario_id">
                                <b-form-select 
                                    id="company-regime_tributario_id"
                                    name="company-regime_tributario_id"
                                    ref="company-regime_tributario_id"
                                    v-model.trim="company.regime_tributario_id" :options="optRegimeTributario"
                                    :readonly="((!isInsert) && (!this.$store.state.user.emp_edi))"       
                                    :class="{ 'form-control is-invalid' : $v.company.regime_tributario_id.$error }">
                                </b-form-select>     
                            </b-form-group>
                        </b-col>
                        <b-col md="2" sm="12">
                            <b-form-group label="*Simples Nacional" label-for="company-fl_simples_nacional">
                                <b-form-select 
                                    id="company-fl_simples_nacional"
                                    name="company-fl_simples_nacional"
                                    ref="company-fl_simples_nacional"
                                    v-model.trim="company.fl_simples_nacional" :options="optSimNao"
                                    :readonly="((!isInsert) && (!this.$store.state.user.emp_edi))"       
                                    :class="{ 'form-control is-invalid' : $v.company.fl_simples_nacional.$error }">
                                </b-form-select>     
                            </b-form-group>                            
                        </b-col>
                        <b-col md="2" sm="12">
                            <b-form-group label="*Status" label-for="company-fl_status">
                                <b-form-select 
                                    id="company-fl_status"
                                    name="company-fl_status"
                                    ref="company-fl_status"
                                    v-model.trim="company.fl_status" :options="optStatus"
                                    :readonly="((!isInsert) && (!this.$store.state.user.emp_edi))"       
                                    :class="{ 'form-control is-invalid' : $v.company.fl_status.$error }">
                                </b-form-select>     
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <hr>
                    <div class="title-emp">
                        <p>Impostos da NFS-e</p>
                    </div>

                    <b-row>
                        <b-col md="12" sm="12">
                            <b-form-group label="*Atividade / CNAE" label-for="company-cnae_id">
                                <b-form-select 
                                    id="company-cnae_id"
                                    name="company-cnae_id"
                                    ref="company-cnae_id"
                                    v-model.trim="company.cnae_id" :options="cnaesCache"
                                    :readonly="((!isInsert) && (!this.$store.state.user.emp_edi))"       
                                    :class="{ 'form-control is-invalid' : $v.company.cnae_id.$error }">
                                </b-form-select>     
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="2" sm="12">
                            <b-form-group label="*Cofins" label-for="company-vlr_cofins">
                                <input 
                                    type="text" 
                                    id="company-vlr_cofins" 
                                    name="company-vlr_cofins" 
                                    ref="company-vlr_cofins" 
                                    style="text-align: right;"
                                    class="form-control" 
                                    :readonly="((!isInsert) && (!this.$store.state.user.emp_edi))"       
                                    v-model.lazy="company.vlr_cofins"
                                    v-money="money" /> 
                            </b-form-group>
                        </b-col>
                        <b-col md="2" sm="12">
                            <b-form-group label="*CSLL" label-for="company-vlr_csll">
                                <input 
                                    type="text" 
                                    id="company-vlr_csll" 
                                    name="company-vlr_csll" 
                                    ref="company-vlr_csll" 
                                    style="text-align: right;"
                                    class="form-control" 
                                    :readonly="((!isInsert) && (!this.$store.state.user.emp_edi))"       
                                    v-model.lazy="company.vlr_csll"
                                    v-money="money" /> 
                            </b-form-group>
                        </b-col>
                        <b-col md="2" sm="12">
                            <b-form-group label="*INSS" label-for="company-vlr_inss">
                                <input 
                                    type="text" 
                                    id="company-vlr_inss" 
                                    name="company-vlr_inss" 
                                    ref="company-vlr_inss" 
                                    style="text-align: right;"
                                    class="form-control" 
                                    :readonly="((!isInsert) && (!this.$store.state.user.emp_edi))"       
                                    v-model.lazy="company.vlr_inss"
                                    v-money="money" /> 
                            </b-form-group>
                        </b-col>
                        <b-col md="2" sm="12">
                            <b-form-group label="*IR" label-for="company-vlr_ir">
                                <input 
                                    type="text" 
                                    id="company-vlr_ir" 
                                    name="company-vlr_ir" 
                                    ref="company-vlr_ir" 
                                    style="text-align: right;"
                                    class="form-control" 
                                    :readonly="((!isInsert) && (!this.$store.state.user.emp_edi))"       
                                    v-model.lazy="company.vlr_ir"
                                    v-money="money" /> 
                            </b-form-group>
                        </b-col>
                        <b-col md="2" sm="12">
                            <b-form-group label="*PIS" label-for="company-vlr_pis">
                                <input 
                                    type="text" 
                                    id="company-vlr_pis" 
                                    name="company-vlr_pis" 
                                    ref="company-vlr_pis" 
                                    style="text-align: right;"
                                    class="form-control" 
                                    :readonly="((!isInsert) && (!this.$store.state.user.emp_edi))"       
                                    v-model.lazy="company.vlr_pis"
                                    v-money="money" /> 
                            </b-form-group>
                        </b-col>
                        <b-col md="2" sm="12">
                            <b-form-group label="*Tributos" label-for="company-vlr_tributos">
                                <input 
                                    type="text" 
                                    id="company-vlr_tributos" 
                                    name="company-vlr_tributos" 
                                    ref="company-vlr_tributos" 
                                    style="text-align: right;"
                                    class="form-control" 
                                    :readonly="((!isInsert) && (!this.$store.state.user.emp_edi))"                                           
                                    v-model.lazy="company.vlr_tributos"
                                    v-money="money" /> 
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="2" sm="12">
                            <b-form-group label="*ISS" label-for="company-vlr_iss">
                                <input 
                                    type="text" 
                                    id="company-vlr_iss" 
                                    name="company-vlr_iss" 
                                    ref="company-vlr_iss" 
                                    style="text-align: right;"
                                    class="form-control" 
                                    :readonly="((!isInsert) && (!this.$store.state.user.emp_edi))"       
                                    v-model.lazy="company.vlr_iss"
                                    v-money="money" /> 
                            </b-form-group>
                        </b-col>
                        <b-col md="4" sm="12">
                            <b-form-group label="*ISS Retido Fonte" label-for="company-fl_iss_retido">
                                <b-form-select 
                                    id="company-fl_iss_retido"
                                    name="company-fl_iss_retido"
                                    ref="company-fl_iss_retido"
                                    v-model.trim="company.fl_iss_retido" :options="optSimNao"
                                    :readonly="((!isInsert) && (!this.$store.state.user.emp_edi))"       
                                    :class="{ 'form-control is-invalid' : $v.company.fl_iss_retido.$error }">
                                </b-form-select>     
                            </b-form-group>
                        </b-col>
                        <b-col md="2" sm="12">
                            <b-form-group label="*Alíquota ISS" label-for="company-aliquota_iss">
                                 <input 
                                    type="text" 
                                    id="company-aliquota_iss" 
                                    name="company-aliquota_iss" 
                                    ref="company-aliquota_iss" 
                                    style="text-align: right;"
                                    class="form-control" 
                                    :readonly="((!isInsert) && (!this.$store.state.user.emp_edi))"       
                                    v-model.lazy="company.aliquota_iss"
                                    v-money="money" /> 
                            </b-form-group>
                        </b-col>                        
                        <b-col md="4" sm="12">
                            <b-form-group label="Nat. Op." label-for="company-natureza_operacao">
                                <b-form-input 
                                    type="text"
                                    id="company-natureza_operacao" 
                                    name="company-natureza_operacao" 
                                    ref="company-natureza_operacao" 
                                    v-model.trim="company.natureza_operacao" 
                                    maxlength="10" 
                                    :readonly="((!isInsert) && (!this.$store.state.user.emp_edi))" >
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="12" sm="12">
                            <b-form-group label="Item da Lista de Serviço (LC116)" label-for="company-lista_servico_id">
                                <b-form-select 
                                    id="company-lista_servico_id"
                                    name="company-lista_servico_id"
                                    ref="company-lista_servico_id"
                                    v-model.trim="company.lista_servico_id" :options="servicesCache"
                                    :readonly="((!isInsert) && (!this.$store.state.user.emp_edi))"       
                                    :class="{ 'form-control is-invalid' : $v.company.lista_servico_id.$error }">
                                </b-form-select>     
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <!--
                    <b-row>
                        <b-col md="3" sm="12">
                            <b-form-group label="Cód. Serviço no Município" label-for="company-cod_servico_municipio">
                                <b-form-input 
                                    type="text"
                                    id="company-cod_servico_municipio" 
                                    name="company-cod_servico_municipio" 
                                    ref="company-cod_servico_municipio" 
                                    v-model.trim="company.cod_servico_municipio" 
                                    :class="{ 'form-control is-invalid' : $v.company.cod_servico_municipio.$error }"
                                    maxlength="5" 
                                    :readonly="((!isInsert) && (!this.$store.state.user.emp_edi))" >
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col md="9" sm="12">
                            <b-form-group label="Descrição do Serviço no Município" label-for="company-desc_servico_municipio">
                                <b-form-input 
                                    type="text"
                                    id="company-desc_servico_municipio" 
                                    name="company-desc_servico_municipio" 
                                    ref="company-desc_servico_municipio" 
                                    v-model.trim="company.desc_servico_municipio" 
                                    :class="{ 'form-control is-invalid' : $v.company.desc_servico_municipio.$error }"
                                    maxlength="600" 
                                    :readonly="((!isInsert) && (!this.$store.state.user.emp_edi))" >
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    -->

                    <!--
                    <b-row>
                        <b-col md="4" sm="12">
                            <b-form-group label="*Município/UF de Prestação do Serviço" label-for="company-municipio_prestacao_id">
                                <b-form-select 
                                    id="company-municipio_prestacao_id"
                                    name="company-municipio_prestacao_id"
                                    ref="company-municipio_prestacao_id"
                                    :options="citiesCache" v-model.trim="company.municipio_prestacao_id" 
                                    :readonly="((!isInsert) && (!this.$store.state.user.emp_edi))"       
                                    :class="{ 'form-control is-invalid' : $v.company.municipio_prestacao_id.$error }">
                                </b-form-select>     
                            </b-form-group>
                        </b-col>
                        <b-col md="3" sm="12">
                            <b-form-group label="*CNPJ Município de Prestação" label-for="company-cnpj_municipio_prestacao">
                                <b-form-input 
                                    type="text"
                                    id="company-cnpj_municipio_prestacao" 
                                    name="company-cnpj_municipio_prestacao" 
                                    ref="company-cnpj_municipio_prestacao" 
                                    v-model.trim="company.cnpj_municipio_prestacao" 
                                    :class="{ 'form-control is-invalid' : $v.company.cnpj_municipio_prestacao.$error }"
                                    v-mask="'##.###.###/####-##'"
                                    :readonly="((!isInsert) && (!this.$store.state.user.emp_edi))" >
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col md="5" sm="12">
                            <b-form-group label="*Descrição do Município de Prestação par DANFSE" label-for="company-nome_municipio_prestacao">
                                <b-form-input 
                                    type="text"
                                    id="company-nome_municipio_prestacao" 
                                    name="company-nome_municipio_prestacao" 
                                    ref="company-nome_municipio_prestacao" 
                                    v-model.trim="company.nome_municipio_prestacao" 
                                    :class="{ 'form-control is-invalid' : $v.company.nome_municipio_prestacao.$error }"
                                    maxlength="100" 
                                    :readonly="((!isInsert) && (!this.$store.state.user.emp_edi))" >
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    -->


                    <b-row>
                        <b-col md="3" sm="12">
                            <b-form-group label="Cód. Serviço no Município" label-for="company-cod_servico_municipio">
                                <b-form-input 
                                    type="text"
                                    id="company-cod_servico_municipio" 
                                    name="company-cod_servico_municipio" 
                                    ref="company-cod_servico_municipio" 
                                    v-model.trim="company.cod_servico_municipio" 
                                    :class="{ 'form-control is-invalid' : $v.company.cod_servico_municipio.$error }"
                                    maxlength="7" 
                                    :readonly="((!isInsert) && (!this.$store.state.user.emp_edi))" >
                                </b-form-input>
                            </b-form-group>
                        </b-col>

                        <b-col md="6" sm="12">
                            <b-form-group label="*Município/UF de Prestação do Serviço" label-for="company-municipio_prestacao_id">
                                <b-form-select 
                                    id="company-municipio_prestacao_id"
                                    name="company-municipio_prestacao_id"
                                    ref="company-municipio_prestacao_id"
                                    :options="citiesCache" v-model.trim="company.municipio_prestacao_id" 
                                    :readonly="((!isInsert) && (!this.$store.state.user.emp_edi))"       
                                    :class="{ 'form-control is-invalid' : $v.company.municipio_prestacao_id.$error }">
                                </b-form-select>     
                            </b-form-group>
                        </b-col>
                        <b-col md="3" sm="12">
                            <b-form-group label="*CNPJ Município de Prestação" label-for="company-cnpj_municipio_prestacao">
                                <b-form-input 
                                    type="text"
                                    id="company-cnpj_municipio_prestacao" 
                                    name="company-cnpj_municipio_prestacao" 
                                    ref="company-cnpj_municipio_prestacao" 
                                    v-model.trim="company.cnpj_municipio_prestacao" 
                                    :class="{ 'form-control is-invalid' : $v.company.cnpj_municipio_prestacao.$error }"
                                    v-mask="'##.###.###/####-##'"
                                    :readonly="((!isInsert) && (!this.$store.state.user.emp_edi))" >
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                        
                    </b-row>

                    <b-row>
                        <b-col md="4" sm="12">
                            <b-form-group label="*Enviar Nota no E-mail da Empresa?" label-for="company-fl_envia_email_emitente">
                                <b-form-select 
                                    id="company-fl_envia_email_emitente"
                                    name="company-fl_envia_email_emitente"
                                    ref="company-fl_envia_email_emitente"
                                    v-model.trim="company.fl_envia_email_emitente" :options="optSimNao"
                                    :readonly="((!isInsert) && (!this.$store.state.user.emp_edi))"       
                                    :class="{ 'form-control is-invalid' : $v.company.fl_envia_email_emitente.$error }">
                                </b-form-select>     
                            </b-form-group>                            
                        </b-col>
                        <b-col md="4" sm="12">
                            <b-form-group label="*Enviar Nota no E-mail do Cliente?" label-for="company-fl_envia_nota_cliente">
                                <b-form-select 
                                    id="company-fl_envia_nota_cliente"
                                    name="company-fl_envia_nota_cliente"
                                    ref="company-fl_envia_nota_cliente"
                                    v-model.trim="company.fl_envia_nota_cliente" :options="optSimNao"
                                    :readonly="((!isInsert) && (!this.$store.state.user.emp_edi))"       
                                    :class="{ 'form-control is-invalid' : $v.company.fl_envia_nota_cliente.$error }">
                                </b-form-select>     
                            </b-form-group>
                        </b-col>
                        <b-col md="4" sm="12">
                            <b-form-group label="*Transmitir NFS-e Automaticamente" label-for="company-fl_emissao_automatica">
                                <b-form-select 
                                    id="company-fl_emissao_automatica"
                                    name="company-fl_emissao_automatica"
                                    ref="company-fl_emissao_automatica"
                                    v-model.trim="company.fl_emissao_automatica" :options="optSimNao"
                                    :readonly="((!isInsert) && (!this.$store.state.user.emp_edi))"       
                                    :class="{ 'form-control is-invalid' : $v.company.fl_emissao_automatica.$error }">
                                </b-form-select>     
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <hr>
                    <div class="title-emp">
                        <p>Configuração de Ambiente</p>
                    </div>

                    <b-row>
                        <b-col md="3" sm="12">
                            <b-form-group label="*Ambiente da API" label-for="company-fl_ambiente">
                                <b-form-select 
                                    id="company-fl_ambiente"
                                    name="company-fl_ambiente"
                                    ref="company-fl_ambiente"
                                    v-model.trim="company.fl_ambiente" :options="optAmbiente"
                                    :readonly="((!isInsert) && (!this.$store.state.user.emp_edi))"       
                                    :class="{ 'form-control is-invalid' : $v.company.fl_ambiente.$error }">
                                </b-form-select>     
                            </b-form-group>
                        </b-col>
                        <b-col md="3" sm="12">
                            <b-form-group label="*Layout da NFS-e" label-for="company-layout_nfse">
                                <b-form-select 
                                    id="company-layout_nfse"
                                    name="company-layout_nfse"
                                    ref="company-layout_nfse"
                                    v-model.trim="company.layout_nfse" :options="optLayout"
                                    :readonly="((!isInsert) && (!this.$store.state.user.emp_edi))"       
                                    :class="{ 'form-control is-invalid' : $v.company.layout_nfse.$error }">
                                </b-form-select>     
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="3" sm="12">
                            <b-form-group label="Sequencial RPS Produção" label-for="company-sequencial_rps">
                                <b-form-input 
                                    type="text"
                                    id="company-sequencial_rps" 
                                    name="company-sequencial_rps" 
                                    ref="company-sequencial_rps" 
                                    v-model.trim="company.sequencial_rps" 
                                    maxlength="10"                  
                                    :readonly="((!isInsert) && (!this.$store.state.user.emp_edi))"              
                                    placeholder="Última Seq. RPS Produção">
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col md="3" sm="12">
                            <b-form-group label="Série NFSe Produção" label-for="company-serie_rps">
                                <b-form-input 
                                    type="text"
                                    id="company-serie_rps" 
                                    name="company-serie_rps" 
                                    ref="company-serie_rps" 
                                    v-model.trim="company.serie_rps" 
                                    :readonly="((!isInsert) && (!this.$store.state.user.emp_edi))"       
                                    maxlength="5"                         
                                    placeholder="Série NFSe Produção">
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col md="3" sm="12">
                            <b-form-group label="Sequencial RPS Homologação" label-for="company-sequencial_rps_homolog">
                                <b-form-input 
                                    type="text"
                                    id="company-sequencial_rps_homolog" 
                                    name="company-sequencial_rps_homolog" 
                                    ref="company-sequencial_rps_homolog" 
                                    v-model.trim="company.sequencial_rps_homolog" 
                                    :readonly="((!isInsert) && (!this.$store.state.user.emp_edi))"       
                                    maxlength="10"                         
                                    placeholder="Última Seq. RPS Homologação">
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col md="3" sm="12">
                            <b-form-group label="Série NFSe Homologação" label-for="company-serie_rps_homolog">
                                <b-form-input 
                                    type="text"
                                    id="company-serie_rps_homolog" 
                                    name="company-serie_rps_homolog" 
                                    ref="company-serie_rps_homolog" 
                                    v-model.trim="company.serie_rps_homolog" 
                                    :readonly="((!isInsert) && (!this.$store.state.user.emp_edi))"       
                                    maxlength="5"                         
                                    placeholder="Série NFSe Homologação">
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                        <br>
                    </b-row>

                    <b-row class="mb-4">
                        <b-col md="12" sm="12">
                            <b-card                                     
                                border-variant="info"
                                header="Notas sobre o gerenciamento automático do RPS"
                                header-bg-variant="info"
                                header-text-variant="white"
                                class="text-left">
                                <b-card-body style="margin-top: -15px;">
                                    <p style="font-weight: 300; margin-bottom: 10px;">
                                        O sequencial do RPS, juntamente com a série, representa uma chave única da nota fiscal de serviço na prefeitura.
                                    </p>
                                    <p style="font-weight: 300; margin-bottom: 10px;">
                                        Basta configurar o número inicial do RPS nos campos acima uma única vez, e a API Fiscal administrará automaticamente o sequenciamento do número do RPS. Você pode obter esta informação consultando o município antes de iniciar a emissão das NFS-e.                                    
                                    </p>                                        
                                    <p style="font-weight: 300;">
                                        A série do RPS varia de acordo com cada prefeitura, podendo ser numérica (1, 2 ou 3, por exemplo) ou alfabética (A, NF, NFS, S, por exemplo). Portanto, consulte o município antes de iniciar a emissão das NFS-e.                                    
                                    </p>                                        
                                </b-card-body>
                            </b-card>
                        </b-col>
                    </b-row>    
                    
                    <hr>
                    <div class="title-emp">
                        <p>Autenticação prefeitura</p>
                    </div>

                    <b-row>
                        <b-col md="3" sm="12">
                            <b-form-group label="Login" label-for="company-login_pref">
                                <b-form-input 
                                    type="text"
                                    id="company-login_pref" 
                                    name="company-login_pref" 
                                    ref="company-login_pref" 
                                    v-model.trim="company.login_pref" 
                                    maxlength="25" 
                                    :readonly="((!isInsert) && (!this.$store.state.user.emp_edi))" >
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col md="3" sm="12">
                            <b-form-group label="Senha" label-for="company-senha_pref">
                                <b-form-input 
                                    type="password"
                                    id="company-senha_pref" 
                                    name="company-senha_pref" 
                                    ref="company-senha_pref" 
                                    v-model.trim="company.senha_pref" 
                                    maxlength="25" 
                                    :readonly="((!isInsert) && (!this.$store.state.user.emp_edi))" >
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row class="mb-4">
                        <b-col md="12" sm="12">
                            <b-card                                     
                                border-variant="info"
                                header="Notas sobre credenciais de autenticação prefeitura"
                                header-bg-variant="info"
                                header-text-variant="white"
                                class="text-left">
                                <b-card-body style="margin-top: -15px;">
                                    <p style="font-weight: 300; margin-bottom: 10px;">
                                        Configuração de "login" e "senha" são os mesmos dados usado para o acesso ao portal da prefeitura pelo contribuinte ou contador da empresa.
                                    </p>
                                    <p style="font-weight: 300; margin-bottom: 10px;">
                                        Utilizaremos elas caso seja exigido na comunicação com o sistema de ISS da prefeitura da sua cidade para autorização em seus webservices, e assim, emitir sua nota fiscal de serviço.
                                    </p>                                        
                                </b-card-body>
                            </b-card>
                        </b-col>
                    </b-row>


                    <hr>
                    <b-row>
                        <b-col md="5" sm="12">
                            <b-form-group label="*Código de Cancelamento Padrão da NFSe" label-for="company-codigo_cancel_nfse">
                                <b-form-select 
                                    id="company-codigo_cancel_nfse"
                                    name="company-codigo_cancel_nfse"
                                    ref="company-codigo_cancel_nfse"
                                    v-model.trim="company.codigo_cancel_nfse" :options="optCodigoCancel"
                                    :readonly="((!isInsert) && (!this.$store.state.user.emp_edi))"       
                                    :class="{ 'form-control is-invalid' : $v.company.codigo_cancel_nfse.$error }">
                                </b-form-select>     
                            </b-form-group>
                        </b-col>
                    </b-row>                    
 
                    <div style="padding: 10px 0px 10px 0px; display: flex; justify-content: end;"> 
                        <b-button class="mr-2" style="width: 150px;"
                            @click="toggleModal">Cancelar
                        </b-button>
                        <b-button id="btn-principal" variant="success" v-if="((isInsert) || (user.emp_edi))" class="mr-2" style="width: 150px;"
                            @click="saveCompany">Salvar 
                        </b-button>
                    </div>

                </b-form>        
            </b-card>
        </div>

		<div id="pageCertificate" v-show="modalActiveCertif">
            <b-card :header="tituloModal"> 

                <b-form @submit.prevent="submit">

                    <input id="usuario_id_companycert" type="hidden" v-model.trim="this.$store.state.user.userid"> 
                    
                    <input id="companycert-id" type="hidden" v-model.trim="companycert.empresa_id"> 

                    <b-row>
                        <b-col md="6" sm="12">
                            <b-form-group label="Razão Social" label-for="companycert-razao">
                                <b-form-input 
                                    type="text" 
                                    id="companycert-razao" 
                                    name="companycert-razao"
                                    ref="companycert-razao"
                                    v-focus
                                    v-model.trim="companycert.razao" 
                                    maxlength="100"
                                    placeholder="Informe a razão social"
                                    readonly>
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col md="3" sm="12">
                            <b-form-group label="CNPJ" label-for="companycert-cnpj">
                                <b-form-input 
                                    type="text"
                                    id="companycert-cnpj" 
                                    name="companycert-cnpj" 
                                    ref="companycert-cnpj" 
                                    v-model.trim="companycert.cnpj" 
                                    v-mask="'##.###.###/####-##'"
                                    placeholder="CNPJ"
                                    readonly>
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col md="3" sm="12">
                            <b-form-group label="Validade Certificado Atual" label-for="companycert-dt_validade_certificado">
                                <b-form-input 
                                    type="text"
                                    id="companycert-dt_validade_certificado" 
                                    name="companycert-dt_validade_certificado" 
                                    ref="companycert-dt_validade_certificado" 
                                    v-model.trim="companycert.dt_validade_certificado" 
                                    maxlength="15" 
                                    placeholder="Validade do certificado"
                                    readonly>
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <hr>
                    <div class="title-emp">
                        <p>Certificado Digital - Modelo A1 (.pxf)</p>
                    </div>

                    <b-row>
                        <b-col md="8" sm="12">
                            <b-form-group label="Arquivo">
                                <b-form-file
                                    type="file" 
                                    id="uploadFile"
                                    name="uploadFile"
                                    ref="uploadFile"
                                    accept=".pfx"
                                    :maxFileSize="512"
                                    refs="uploadFile"
                                    v-model="fileCert"
                                    :state="Boolean(fileCert)"
                                    @change="onUploadFileChange"
                                    placeholder="Escolha um arquivo ou solte-o aqui..."
                                    drop-placeholder="Solte o arquivo aqui...">
                                </b-form-file>

                            </b-form-group>
                        </b-col>                    
                        <b-col md="4" sm="12">
                            <b-form-group label="Senha do Certificado">
                                <b-form-input 
                                    type="password"
                                    id="senhaCertificado" 
                                    name="senhaCertificado" 
                                    ref="senhaCertificado"
                                    class="inputpass"
                                    v-model.trim="companycert.senha_certificado" 
                                    maxlength="50" 
                                    placeholder="Informe a senha do certificado">
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <hr>
                    <div style="padding: 10px 0px 10px 0px; display: flex; justify-content: end;"> 
                        <b-button class="mr-2" style="width: 150px;"
                            @click="toggleModalCertificate">Cancelar
                        </b-button>  
                        <b-button variant="success" id="btn-principal-up" v-if="mode === 'save'" class="mr-2" style="width: 150px;"  
                            @click="uploadCertificateBase64">Upload 
                        </b-button>
                    </div>
                </b-form>        
            </b-card>
        </div>

    </div>  
</template>

<script>
import { baseApiUrl, showError } from '@/global'
import { mapState } from 'vuex'
import axios from 'axios'
import PageTitle from '../template/PageTitle'
import Modal  from '../template/Modal'
import { required, minLength, email } from "vuelidate/lib/validators";
import formMixin from '../../config/mixinform';
import {VMoney} from 'v-money'
//modulo function debounce
// import { debounce } from '../../config/debounce.js';

// Cache local
import citiesJson from '../../cache-data/municipios.json'
import cnaesJson from '../../cache-data/cnaes.json'
import servicesJson from '../../cache-data/listaservicos.json'

export default {
    name: 'Empresas',
    computed: mapState(['user']),
    components: { PageTitle, Modal },
    mixins: [ formMixin ],

    data: function () {
        return {
            mode: 'save',
            modalActive: false,
            modalActiveCertif: false,
            tituloModal: null,
            isInsert: false,            

            company: {},
            companys: [],
            companies: [],
            companycert: {},
            fileCert: null,
            arquivoBase64: '',
            
            fields: [
                { key: 'nm_empresa', label: 'Empresa' },
                { key: 'cnpj', label: 'CNPJ' },
                { key: 'status', label: 'Status' },
                { key: 'ambiente', label: 'Ambiente NFS-e' },
                { key: 'actions', label: 'Ações', class: 'text-center' }
            ],
            page: 1,
            count: 0,
            limit: 0,

            optSimNao: [
                { value: "S", text: 'Sim' },
                { value: "N", text: 'Não' }
            ],

            optStatus: [
                { value: "A", text: 'Ativo' },
                { value: "I", text: 'Inativo' }
            ],

            optRegimeTributario: [
                { value: "1", text: 'Microempresa municipal' },
                { value: "2", text: 'Estimativa' },
                { value: "3", text: 'Sociedade de profissionais' },
                { value: "4", text: 'Cooperativa' },
                { value: "5", text: 'MEI' },
                { value: "6", text: 'ME EPP' }
            ],

            optAmbiente: [
                { value: "P", text: 'Produção' },
                { value: "H", text: 'Homologação' }
            ],

            optLayout: [
                { value: "0", text: 'Provedor' },
                { value: "1", text: 'Padrão Nacional' }
            ],

            optCodigoCancel: [
                { value: "1", text: 'Erro na Emissão' },
                { value: "2", text: 'Serviço não Prestado' },
                { value: "4", text: 'Duplicidade da Nota' }
            ],

            citiesCache: [],
            cnaesCache: [],
            servicesCache: [],

            money: {
                decimal: ',',
                thousands: '.',	
                prefix: '',
                suffix: '',
                precision: 2,
                masked: false 
            }
        }
    },
    // Create function with delay
    // created () {
    //     this.debouncedInput = debounce((event)=>this.checkCepComplete(event), 500);
    // },
    validations: {
        company: {
            razao: { required },
            fantasia: { required },
            cnpj: { required, minLength: minLength(18) },
            im: { required },
            cep: { required, minLength: minLength(8) },
            endereco: { required },
            numero: { required },
            bairro: { required },
            municipio_id: { required },
            telefone: { required, minLength: minLength(13) },
            email: { required, email },
            regime_tributario_id: { required },
            fl_ambiente: { required },
            fl_status: { required },
            cnae_id: { required },
            fl_iss_retido: { required },
            lista_servico_id: { required },
            cod_servico_municipio: { required },
            ///desc_servico_municipio: { required },
            municipio_prestacao_id: { required },
            cnpj_municipio_prestacao: { required, minLength: minLength(18) },
            ///nome_municipio_prestacao: { required },
            fl_envia_email_emitente: { required },
            fl_envia_nota_cliente: { required },
            fl_emissao_automatica: { required },
            codigo_cancel_nfse: { required },
            fl_simples_nacional: { required },
            layout_nfse: { required }
        }
    },

    directives: {money: VMoney},

    methods: {
        loadCompanies() {
            axios.get(`${baseApiUrl}/empresa/usuario/${this.$store.state.user.userid}/pagina/${this.page}`)
                 .then(resp => {
                     this.companys = resp.data.data
                     this.count = parseInt(resp.data.count)
                     this.limit = parseInt(resp.data.limit)
            })
        },

        loadCitiesCache() {
            let cities = citiesJson.map(city => {
                return { value: city.municipio_id, text: city.nm_municipio }
            })
            this.citiesCache = cities
        },

        loadCnaesCache() {
            let cnaes = cnaesJson.map(cnae => {
                return { value: cnae.cnae_id, text: cnae.nm_cnae }
            })
            this.cnaesCache = cnaes
        },

        loadServicesCache() {
            let services = servicesJson.map(service => {
                return { value: service.lista_servico_id, text: service.nm_servico }
            })
            this.servicesCache = services
        },

        loadCompany(company, mode = 'save') {
            this.mode = mode

            axios.get(`${baseApiUrl}/empresa/empresa/${company.empresa_id}`)
                 .then(resp => {
                     this.company = resp.data.data
            })

            this.tituloModal = 'Editar Empresa'
            this.toggleModal()
        },

        addCompany() {
            this.company = {}
            this.tituloModal = 'Adicionar Empresa'
            this.toggleModal()
            this.isInsert = true
        },

        toggleModal() {
            this.modalActive = !this.modalActive;
            if (this.modalActive === false) {
                this.reset()
            }
            this.$v.$reset();            
		},

        loadCompanyCertificate(company, mode = 'save') {
            this.mode = mode
           
            axios.get(`${baseApiUrl}/empresa/certificado/empresa/${company.empresa_id}`)
                 .then(resp => {
                     this.companycert = resp.data.data
            })

            this.tituloModal = 'Certificado da Empresa'
            this.toggleModalCertificate()
        },

        onUploadFileChange(e) {
            const selectedFile = e.target.files[0]; 
            this.createBase64File(selectedFile);
        },
        
        createBase64File(file) {
            if(!file)return
            const reader = new FileReader();
            reader.onload = (e) => {
                this.arquivoBase64 = e.target.result;
            };
            reader.readAsDataURL(file);
        },

        uploadCertificateBase64() {            
            // Localiza e converte o arquivo selecionado
            var arquivo = document.getElementById('uploadFile').value;
            if (arquivo == "") {
                this.$toasted.global.defaultError({ msg: 'Favor seleciona o arquivo do certificado!'})
                document.getElementById('uploadFile').focus()
                return
            } 
            var senha = document.getElementById('senhaCertificado').value;
            if (senha == "") {
                this.$toasted.global.defaultError({ msg: 'Favor informar a senha do certificado!'})
                document.getElementById('senhaCertificado').focus()
                return
            } 

            // Se tudo ok, prossegue enviando para API!
            let URL = `${baseApiUrl}/empresa/certificado/upload/empresa/${this.companycert.empresa_id}`

            let cnpj = this.companycert.cnpj.replace(/[^0-9]/g, '')

            // Payload do arquivo em Base64
            const { arquivoBase64 } = this;

            // Headers auxiliares para ajudar na geração do arquivo no lado servidor
            const headers = { 
                'Content-Type': 'application/json',
                'x-file-name': this.fileCert.name,
                'x-file-size': this.fileCert.size,
                'x-file-type': this.fileCert.type,
                'x-file-pass': senha,
                'x-file-key': cnpj
            }

            axios.post(URL, arquivoBase64, { headers })
                .then(() => {
                    this.$toasted.global.defaultSuccess({ msg: 'Certificado digital atualizado!'})
                })
                .catch(showError)

            this.toggleModalCertificate()
        },

        toggleModalCertificate() {
            this.modalActiveCertif = !this.modalActiveCertif;
            this.companycert = {} // Reset
            this.fileCert = null
            this.arquivoBase64 = ''
            this.$refs.uploadFile.reset()
		},

        reset() {
            this.mode = 'save'
            this.isInsert = false
            this.company = {}
            this.loadCompanies()
        },

        focusFirstError() {
            var invalidFields = Object.keys(this.$v.$params).filter(fieldName => this.$v[fieldName].$invalid);
            if (invalidFields) {
                this.$refs.input.$refs.input.focus()
            }
        },

        saveCompany() {
            // Campos selects que o Vue validate não esta pegando corretamente - BUG
            if (!this.company.municipio_id) {
                this.$toasted.global.defaultError({ msg: "Informe Município/UF" })
                document.getElementsByName('company-municipio_id')[0].focus()
                return
            } 
            if (!this.company.regime_tributario_id) {
                this.$toasted.global.defaultError({ msg: "Informe Regime Tributário" })
                document.getElementsByName('company-regime_tributario_id')[0].focus()
                return
            } 
            if (!this.company.fl_simples_nacional) {
                this.$toasted.global.defaultError({ msg: "Informe Simples Nacional" })
                document.getElementsByName('company-fl_simples_nacional')[0].focus()
                return
            } 
            if (!this.company.fl_status) {
                this.$toasted.global.defaultError({ msg: "Informe Status" })
                document.getElementsByName('company-fl_status')[0].focus()
                return
            } 
            if (!this.company.cnae_id) {
                this.$toasted.global.defaultError({ msg: "Informe Atividade / CNAE" })
                document.getElementsByName('company-cnae_id')[0].focus()
                return
            } 
            if (!this.company.fl_iss_retido) {
                this.$toasted.global.defaultError({ msg: "Informe ISS Retido Fonte" })
                document.getElementsByName('company-fl_iss_retido')[0].focus()
                return
            } 
            if (!this.company.lista_servico_id) {
                this.$toasted.global.defaultError({ msg: "Informe Item da Lista de Serviço (LC116)" })
                document.getElementsByName('company-lista_servico_id')[0].focus()
                return
            } 
            if (!this.company.municipio_prestacao_id) {
                this.$toasted.global.defaultError({ msg: "Informe Município/UF de Prestação do Serviço" })
                document.getElementsByName('company-municipio_prestacao_id')[0].focus()
                return
            } 
            if (!this.company.fl_envia_email_emitente) {
                this.$toasted.global.defaultError({ msg: "Informe Enviar Nota no E-mail da Empresa" })
                document.getElementsByName('company-fl_envia_email_emitente')[0].focus()
                return
            } 
            if (!this.company.fl_envia_nota_cliente) {
                this.$toasted.global.defaultError({ msg: "Informe Enviar Nota no E-mail do Cliente" })
                document.getElementsByName('company-fl_envia_nota_cliente')[0].focus()
                return
            } 
            if (!this.company.fl_emissao_automatica) {
                this.$toasted.global.defaultError({ msg: "Informe Transmitir NFS-e Automaticamente" })
                document.getElementsByName('company-fl_emissao_automatica')[0].focus()
                return
            } 
            
            if (this.validate()) {
                const method = this.company.empresa_id ? 'put' : 'post'
                const id = this.company.empresa_id ? `/${this.company.empresa_id}` : ''
                const usuario = `/usuario/${this.$store.state.user.userid}`
                const registro = this.company.empresa_id ? '' : `/registro/${this.$store.state.user.regid}`
                const url = `${baseApiUrl}/empresa${id}${usuario}${registro}`

                axios[method](url, this.company)
                    .then(() => {
                        this.$toasted.global.defaultSuccess()
                        this.reset()
                    })
                    .catch(showError)
              
                this.toggleModal()
            }
        },
 
        removeCompany(company) {
            this.company = { ...company } 
            this.$refs.modalRemove.show(company);
        },

        hideRemove() { 
            this.$refs.modalRemove.hide();
        },

        confirmeRemove() { 
            this.hideRemove();

            const id = this.company.empresa_id
            axios.delete(`${baseApiUrl}/empresa/${id}`)
                 .then(() => {
                     this.$toasted.global.defaultSuccess()
                     this.reset()
                 })
                 .catch(showError)
        },

        buscarCep() {
            if (this.company.cep) {
                document.getElementById('company-endereco').value = ''
                document.getElementById('company-numero').value = ''
                document.getElementById('company-bairro').value = ''
                document.getElementById('company-complemento').value = ''
                document.getElementById('company-municipio_id').value = ''
                this.company.endereco = null
                this.company.numero = null
                this.company.bairro = null
                this.company.complemento = null
                this.company.municipio_id = null

                axios.get(`${baseApiUrl}/endereco/cep/${this.company.cep}`)
                    .then(resp => {
                        if (resp.data.status) {
                            this.$toasted.global.defaultSuccess({ msg: resp.data.mensagem })
                            if (resp.data.logradouro !== '') {
                                document.getElementById('company-endereco').value = resp.data.logradouro
                                this.company.endereco = resp.data.logradouro
                            }
                            if (resp.data.bairro !== '') {
                                document.getElementById('company-bairro').value = resp.data.bairro
                                this.company.bairro = resp.data.bairro
                            }
                            if (resp.data.complemento !== '') {
                                document.getElementById('company-complemento').value = resp.data.complemento
                                this.company.complemento = resp.data.complemento
                            }
                            if (resp.data.ibge !== '') {
                                document.getElementById('company-municipio_id').value = resp.data.ibge
                                this.company.municipio_id = resp.data.ibge
                            }
                        } else 
                        {
                            this.$toasted.global.defaultWarning({ msg: resp.data.mensagem })
                        }
                    })
                    .catch(showError) 
            }
        }        
    },

    watch: {
        page() {
            this.loadCompanies()
        }
    },

    mounted() {
        this.loadCompanies() 
        this.loadCitiesCache()
        this.loadCnaesCache()
        this.loadServicesCache()
    }    
}

</script>

<style scoped>
    .title-emp {
        flex: 1;
        display: grid;
    }

    .error {
        border: 3px solid darkred;        
    }

    p {
        font-weight: 600;
        margin-bottom: 10px;
    }

    hr {
        border: 0;
        width: 100%;
        height: 1px;
        margin-top: 15px;
        margin-bottom: 20px;
        background-image: linear-gradient(to right,
            rgba(120, 120, 120, 0),
            rgba(120, 120, 120, 0.75),
            rgba(120, 120, 120, 0));
    }   
    
    #app .inputpass {
        height: 39px;
    }
</style>